import React from "react";
import { NumericInput, InputGroup } from "@blueprintjs/core";

const CurrencyInput = ({
  value,
  onChange = () => {},
  leftIcon = "dollar",
  id = "text-input",
  ...props
}) => {
  return (
    <InputGroup
      type="number"
      min="0"
      {...props}
      value={value}
      onChange={onChange}
      onBlur={() =>
        onChange({
          target: {
            value:
              value &&
              parseFloat(Math.abs(value))
                .toFixed(2)
                .toString()
          }
        })
      }
      id={id}
      leftIcon={leftIcon}
      fill
      buttonPosition="none"
    />
  );
};

export default CurrencyInput;
